import React, { useState } from 'react';
import './Layout.css';

const Layout = ({ title, renderSidebar, children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen((open) => !open);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <div className="app-container">
      {renderSidebar({ isOpen: isSidebarOpen, closeSidebar })}

      {isSidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar}></div>}

      <main className="main-content">
        <header className="mobile-header">
          <button className="menu-btn" onClick={toggleSidebar}>☰</button>
          <h1>{title}</h1>
        </header>
        <div className="content-wrapper">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
